import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'image-fullscreen',
  templateUrl: './image-fullscreen.component.html',
  styleUrls: ['./image-fullscreen.component.scss']
})
export class ImageFullscreenComponent {
  @Input() src: string;
  @Input() isShowBtn: boolean;
  @Output() close = new EventEmitter();
  @Output() prev = new EventEmitter();
  @Output() next = new EventEmitter();
  isHide: boolean;

  constructor() { }

}
